// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 5026 ? "DashboardContainer" : chunkId) + "." + {"4513":"a2043a1b8df966c94875","5026":"56468330919e982f23a6","5527":"99315f9fc14204e9a1e2","7867":"a15ed4c0a0e11435b528","8957":"705dd3a105cb9a4a4864"}[chunkId] + ".chunk.css";
};